import React from "react";
import Text from "../../../../shared/components/Text";
import { formatMoney } from "nemuru-components";
import { getMinDownPaymentValueByAssetAmount } from "../utils/downPaymentCalculation";

export const HintDownPaymentImportLabel = ({
  autoPrice,
  maxAutoDownPayment,
}) => (
  <>
    <Text
      tId={"FROM_X_TO_Y"}
      dynamicDataTexts={[
        formatMoney(getMinDownPaymentValueByAssetAmount(autoPrice), 0),
        formatMoney(maxAutoDownPayment, 0),
      ]}
    />
  </>
);
